import React, { useEffect } from 'react'
import { connect } from 'react-redux'

import {
  ReactModal,
  SearchAndSelect,
  TextArea,
  Button,
} from '../../../../../components'
import { IMG } from '../../../../../themes'
import { cutString2 } from '../../../../../helpers'
import { ISSUE, REPORT } from '../../../../../helpers/constants'

import {
  StyleHeader,
  StyleContent,
  StyleFooter,
} from './style'

const IssueManagementReportModal = (props) => {
  const {
    isVisible,
    isOpenDropdown,
    isFocusDropdown,
    isErrorDropdown,
    orders,
    getOrders,
    language,
    colorTheme,
    searchDropdown,
    selectedDropdown,
    issueDetail,
    images,
    onClose,
    onSelectedDropdown,
    onChangeSearchDropdown,
    onClearSelectedDropdown,
    onFocusDropdown,
    onBlurDropdown,
    onChangeIssueDetail,
    onCreateIssue,
    onUploadImage,
    onDeleteImage,
  } = props

  const otherOption = { itemId: '', name: REPORT.OTHER[language] }
  const descriptionImage = `${ISSUE.UPLOAD_IMG[language]} : ${images ? images.length : 0}`

  let list = [...orders, otherOption]

  useEffect(() => {
    if (isVisible && isFocusDropdown && getOrders) {
      getOrders()
    }
  }, [isVisible])

  const previewImages = (images) => {
    if (!images) {
      return
    }

    return (
      <div className='preview-images'>
        {images.map((image, i) => {
          const fileName = image.file.name

          return (
            <div
              key={fileName}
              className='image-layout'
            >
              <img
                className='small-image'
                src={image.data}
                alt={fileName}
              />
              <span className='filename-image'> {cutString2(image.file.name, 16)}</span>
              <img
                onClick={() => onDeleteImage(image.id)}
                className='delete-image'
                src={IMG['clear_round.svg']}
                alt='clear_round.svg'
              />
            </div>
          )
        })}
      </div>
    )
  }

  return (
    <ReactModal isVisible={isVisible} width={600}>
    {/* <ReactModal isVisible={isOpenIssueReportModal} width={600}>  */}
      <StyleHeader>
        <label className='header-issue-modal'>{ISSUE.ADD[language]}</label>
      </StyleHeader>

      <StyleContent colorTheme={colorTheme}>
        <SearchAndSelect
          isOpenDropdown={isOpenDropdown}
          language={language}
          colorTheme={colorTheme}
          placeholder={ISSUE.CHOOSE_ISSUE[language]}
          className={isErrorDropdown && !selectedDropdown && 'error-dropdown'}
          classInput='input-data'
          onChangeSearch={onChangeSearchDropdown}
          keyword={searchDropdown}
          onClickList={onSelectedDropdown}
          list={list}
          clearSearch={onClearSelectedDropdown}
          onFocus={onFocusDropdown}
          onBlur={onBlurDropdown}
        />

        <div className='title-field'>{ISSUE.DETAIL[language]}:</div>
        <TextArea
          onChange={onChangeIssueDetail}
          value={issueDetail}
          placeholder={ISSUE.TEXT_DETAIL[language]}
          className='text-area-issue'
        />
        
        <div className='title-field'>{ISSUE.UPLOAD_IMG[language]}:</div>
        <div className='description-image'>{ISSUE.TEXT_UPLOAD[language]}</div>
        <label className='upload-button'>
          {ISSUE.CHOOSE_FILE[language]}
          <input
            multiple
            type='file'
            accept='image/x-png,image/jpg,image/jpeg'
            onChange={onUploadImage}
          />
        </label>
        <div className='description-image'>
          {descriptionImage}
        </div>

        {previewImages(images)}
      </StyleContent>

      <StyleFooter colorTheme={colorTheme}>
        <Button
          name={ISSUE.BACK[language]}
          className='back-button'
          onClick={onClose}
        />
        <Button
          name={ISSUE.SAVE[language]}
          className='save-button'
          onClick={onCreateIssue}
        />
      </StyleFooter>
    </ReactModal>
  )
}

const mapStateToProps = ({ modalReducer }) => {
  return {
    isOpenIssueReportModal: modalReducer.orderModal.modalReducer
  }
}

const mapDispatchToProps = () => {
  return {

  }
}

export default connect(mapStateToProps, mapDispatchToProps)(IssueManagementReportModal)
